import React from 'react';
import { Invoice, CompanyInfo } from '../types';
import { X, Printer } from 'lucide-react';
import { printContent } from '../utils/print';
import { getCollectionNoticeHtml } from '../utils/printTemplates';

interface InvoiceReceiptProps {
  invoice: Invoice;
  companyInfo: CompanyInfo | null;
  onClose: () => void;
}

const InvoiceReceipt: React.FC<InvoiceReceiptProps> = ({ invoice, companyInfo, onClose }) => {
  const handlePrint = () => {
    const html = getCollectionNoticeHtml(invoice, companyInfo, [], true);
    printContent(`وصل إيجار - ${invoice.tenantName}`, html);
  };

  return (
    <div 
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fadeIn"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white w-full max-w-2xl shadow-2xl relative flex flex-col rounded-2xl overflow-hidden max-h-[90vh]">
        
        {/* UI Header (Hidden on print) */}
        <div className="p-4 bg-slate-50 border-b border-slate-200 flex justify-between items-center print:hidden shrink-0">
          <button 
            onClick={handlePrint}
            className="px-5 py-2.5 bg-slate-950 text-white rounded-xl font-bold flex items-center gap-2 hover:bg-slate-800 transition-all active:scale-95 text-sm shadow-md"
          >
            <Printer size={16} />
            <span>طباعة الوصل</span>
          </button>
          <div className="font-bold text-slate-800 text-sm">عرض وتفاصيل وصل الإيجار</div>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors active:scale-90">
             <X size={20} className="text-slate-400" />
          </button>
        </div>

        {/* Scrollable Receipt Content */}
        <div className="flex-1 overflow-y-auto p-6 sm:p-8 custom-scrollbar print:p-0 bg-slate-100/30 print:bg-white">
          <div 
            className="max-w-2xl mx-auto shadow-sm border border-slate-200 rounded-xl overflow-hidden print:border-0 print:shadow-none"
            dangerouslySetInnerHTML={{ __html: getCollectionNoticeHtml(invoice, companyInfo, [], true) }}
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceReceipt;
